module.exports = __webpack_public_path__ + "images/4e5642063ef24128f8fe2fa6d8a19224.png";